module.exports = __webpack_public_path__ + "img/eye.d3f5988.svg";